import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import InvoiceDownloadPage from 'src/components/trainings/InvoiceDownloadPage';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const Builder = lazy(() => import('src/pages/builder/Builder'));
const Cookies = lazy(() => import('src/pages/builder/Cookies'));
const LegalNotice = lazy(() => import('src/pages/builder/LegalNotice'));
const WebSite = lazy(() => import('src/pages/builder/WebSite'));
const PrivacyPolicy = lazy(() => import('src/pages/builder/PrivacyPolicy'));
const TrainingPage = lazy(() => import('src/pages/builder/TrainingPage'));
const PreviewPage = lazy(() => import('src/pages/builder/PreviewPage'));

// ----------------------------------------------------------------------

export const BuilderRoutes = [
  {
    path: 'builder',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <Builder />, index: true },
    ],
  },
];

export const WebSiteRoute = [
  {
    path: 'web/user/:id',
    element: (
        <FormLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </FormLayout>
    ),
    children: [
      { element: <WebSite />, index: true },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
      { path: 'cookies', element: <Cookies /> },
      { path: 'legal-notice', element: <LegalNotice /> },
    ],
  },
  {
    path: 'web/trainings/:sessionID/userID/:userID',
    element: (
      <TrainingPage />
    ),
  },
  {
    path: 'preview/:name',
    element: (
      <PreviewPage />
    ),
  },
]


